<template>
  <div>
    <Drawer :title="title" width="900" :value="detailUserID>0" :mask-closable="true" @on-close="$emit('close')">
      <driverDetail v-if="baseInfo.user_type===1 || baseInfo.user_type===2" :base-info="baseInfo"></driverDetail>

      <supplierDetail v-if="baseInfo.user_type===3" :base-info="baseInfo"></supplierDetail>

    </Drawer>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import supplierDetail from "./supplierDetail";
  import driverDetail from "./edit";
  export default {
    name: "detail",
    components:{pageTable,supplierDetail,driverDetail},
    props:{
      user_id:{
        type:Number,
        default: 0
      }
    },
    data(){
      return {
        baseInfo:{},
        title:'',
        detailUserID:0,
      }
    },
    methods:{
      async getInfo(){
        if (this.detailUserID<=0)  return  false;
        let res = await this.$commonFun.postProxy('admin/user/getDetailInfo',{user_id:this.detailUserID});
        this.$commonFun.dealApiResult(res,()=>{
          this.baseInfo = res.data
          this.title = this.setTitle();
        })
      },
      setTitle(){
        if (this.baseInfo.user_type === 1){
          return '散户司机详情';
        }else if(this.baseInfo.user_type === 2){
          return '车队司机详情';
        }else if(this.baseInfo.user_type ===3){
          return '站点用户详情';
        }else{
          return '用户详情';
        }
      },
      reloadPage(user_id){
        this.detailUserID = user_id
        this.getInfo()
      }
    },
    mounted() {

    },
    watch:{
      user_id(new_user_id,old_user_id){
        this.reloadPage(new_user_id)
      }
   }
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

</style>
